import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import RemoveIcon from '@mui/icons-material/Remove';
import { IconButton, Stack } from '@mui/material';
import dayjs from 'dayjs';
import strings from '../../Globalization';
import consts from '../../consts';
import Model from '../../models/model';

const model = new Model({
	name: 'IncubatorCycle',
	combos: [],
	customizeSaveData: (values, { activeRecord }) => ({
		...values,
		BIResult: values.BIResult || activeRecord.record.BIResult || 0,
		ExpiryDate: values.ExpiryDate || activeRecord.record.ExpiryDate || '',
		BILotNumberId: values.BILotNumberId || 0,
		SterilizerId: activeRecord?.data?.SterilizerId,
		SterilizerCycleId: activeRecord?.data?.SterilizerCycleId,
		MinTemp: values.MinTemp || 0,
		MaxTemp: values.MaxTemp || 0,
		BIInTime: values.BIInTime || dayjs().format(consts.MomentFormat.DateTimeFormat),
		BIReadTime: values.BIReadTime || dayjs().format(consts.MomentFormat.DateTimeFormat)
	}),
	columns: [
		{
			field: 'BILotNumberId',
			header: 'LotNumber',
			label: 'LotNumber',
			lookup: 'BILotNumber',
			inputWhen: ({ activeRecord }) => activeRecord?.resultType === consts.ResultType.BIResult,
			inlineLabelSize: 12
		},
		{
			field: 'ExpiryDate',
			header: 'ExpiryDate',
			label: 'ExpiryDate',
			type: 'date',
			inputWhen: ({ activeRecord }) => activeRecord?.resultType === consts.ResultType.BIResult,
			inlineLabelSize: 12,
			format: consts.MomentFormat.Date
		},
		{
			field: 'BIResult',
			header: 'BIResult',
			label: 'BIResult',
			required: ({ activeRecord }) => activeRecord?.resultType === consts.ResultType.BIResult,
			options: [
				{ id: consts.BIResult.Positive, label: strings.Positive, Icon: AddIcon, color: 'error' },
				{ id: consts.BIResult.Negative, label: strings.Negative, Icon: RemoveIcon, color: 'success' }
			],
			inputWhen: ({ activeRecord }) => activeRecord?.resultType === consts.ResultType.BIResult,
			inlineLabelSize: 12,
			type: 'number',
			customizeInput: ({ inputProps: { formik, field, column, activeRecord } }) => {
				const handleOnClick = (val) => () => {
					formik.setFieldValue(field, val);
				};
				return (
					<Stack
						direction="row"
						columnGap={2}
						sx={{
							'& .optionHighlighted': {
								backgroundColor: (theme) => theme.palette.divider
							}
						}}
					>
						{column.options.map(({ id, label, Icon, color }, index) => (
							<IconButton
								type="button"
								className={formik.values[field] === id ? 'optionHighlighted' : ''}
								onClick={handleOnClick(id)}
								title={label}
								color={color}
								key={`option-${index}`}
							>
								<Icon fontSize="inherit" />
							</IconButton>
						))}
					</Stack>
				);
			}
		},
		{
			field: 'CILotNumberId',
			header: 'LotNumber',
			label: 'LotNumber',
			lookup: 'CILotNumber',
			inlineLabelSize: 12
		},
		{
			field: 'CIResult',
			header: 'CIResult',
			label: 'CIResult',
			required: true,
			options: [
				{ id: consts.CIResult.Check, label: strings.Check, Icon: CheckIcon, color: 'success' },
				{ id: consts.CIResult.Cross, label: strings.Cross, Icon: CloseIcon, color: 'error' }
			],
			type: 'number',
			inlineLabelSize: 12,
			customizeInput: ({ inputProps: { formik, field, column, activeRecord } }) => {
				const handleOnClick = (val) => () => {
					formik.setFieldValue(field, val);
				};
				return (
					<Stack
						direction="row"
						columnGap={2}
						sx={{
							'& .optionHighlighted': {
								backgroundColor: (theme) => theme.palette.divider
							}
						}}
					>
						{column.options.map(({ id, label, Icon, color }, index) => (
							<IconButton
								type="button"
								className={formik.values[field] === id ? 'optionHighlighted' : ''}
								onClick={handleOnClick(id)}
								title={label}
								color={color}
								key={`option-${index}`}
							>
								<Icon fontSize="inherit" />
							</IconButton>
						))}
					</Stack>
				);
			}
		}
	]
});

export default model.createFormDialog();
